import {
  ALIGN_BOTTOM_BETWEEN_OBJECTS_LINE_ID,
  ALIGN_LEFT_BETWEEN_OBJECTS_LINE_ID,
  ALIGN_RIGHT_BETWEEN_OBJECTS_LINE_ID,
  ALIGN_TOP_BETWEEN_OBJECTS_LINE_ID,
  H_LINE_ID, HORIZONTAL_LINE_OF_INTERSECT_IN_CENTER_OF_OBJECTS,
  V_LINE_ID, VERTICAL_LINE_OF_INTERSECT_IN_CENTER_OF_OBJECTS
} from "@/common/preview/positioning-lines";
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { deepCopy } from "@frontend/utils";
import { copyAndResizeEventBroker, EVENTS } from './event-broker';
import { resizeTemplateHandler } from "./handlers/resize-template-handler";
import { getResizedObjectsData, replaceSizeIntoTitleOfTemplate } from "./helpers";
import { FIELD_TYPE_BACKGROND_THEME_IMAGE } from "@frontend/constants/type-fields-of-template";
import { DEFAULT_BACKGROUND_THEME_IMAGE_FIELD_PROPERTIES } from '@frontend/group/modules/additional-fields'
import store from "@frontend/store";
import { GRID_SIZING_VIEW, PROPORTIONAL_SIZING_VIEW } from "@frontend/constants/layout-sizing-view";
import { DEFAUL_GRID_COLUMNS } from "@frontend/constants/grid-stack-options";
import { resizeAITemplateHandler } from "@frontend/group/modules/copy-and-resize/handlers/resize-ai-template-handler";
import ZoomService from "@frontend/group/services/ZoomService";

const NOT_PROCESSED_OBJECTS = [
  'pixel_background',
  H_LINE_ID,
  V_LINE_ID,
  ALIGN_TOP_BETWEEN_OBJECTS_LINE_ID,
  ALIGN_BOTTOM_BETWEEN_OBJECTS_LINE_ID,
  ALIGN_LEFT_BETWEEN_OBJECTS_LINE_ID,
  VERTICAL_LINE_OF_INTERSECT_IN_CENTER_OF_OBJECTS,
  HORIZONTAL_LINE_OF_INTERSECT_IN_CENTER_OF_OBJECTS,
  ALIGN_RIGHT_BETWEEN_OBJECTS_LINE_ID,
];

const MODAL_TITLES = {
  COPY_AND_RESIZE: 'Copy and Resize Template',
  RESIZE: 'Resize Template'
}

const getShowPageScope = () => ShowPageScopeCollector.get([
  'previews',
  'canvas_data',
  'layoutChanges',
  'getChangesLayoutById',
  'saveLayout',
  'updateLayoutChanges',
  'handleObjectMoving',
  'onClickDuplicateTemplateButton',
  'layout_options',
]);

let currentPreview = null,
  copyAndResizeButtonContext = null;

export function changeNameOfTemplate(width, height, _preview = currentPreview) {
  const $templateNameCanvas = $(_preview.canvas.upperCanvasEl)
    .closest('.template-item')
    .find('.template-name-canvas');

  $templateNameCanvas.text(
    replaceSizeIntoTitleOfTemplate(
      $templateNameCanvas.text(),
      width,
      height
    )
  );
}

export function changeTemplateCanvasElement(newWidth, newHeight, _preview = currentPreview, options = {}) {
  const { layout_options } = getShowPageScope();
  const templateGroupPreviewWidth = Number($("#template-group-preview").width()) || 0;
  const currentCanvasWidths = options.useCurrentPreviewWidth
    ? (window.previews || [])
      .map(preview => Number(preview.canvas?.wrapperEl?.clientWidth || $(preview.canvas?.wrapperEl).width()) || 0)
    : [];
  const widthTemplateGroupPreview = Math.max(templateGroupPreviewWidth, ...currentCanvasWidths);
  const nextDimension = [...(_preview.dimension || [])];
  nextDimension[0] = newWidth;
  nextDimension[1] = newHeight;

  for (const object of _preview.canvas.getObjects()) {
    if (object.id !== 'pixel_background') {
      continue;
    }

    const bounds = object.getBoundingRect(true, true);
    const coversCanvas = bounds.left <= 0 && bounds.top <= 0
      && bounds.left + bounds.width >= _preview.dimension[0]
      && bounds.top + bounds.height >= _preview.dimension[1];

    if (coversCanvas) {
      object.set({ left: 0, top: 0, width: newWidth, height: newHeight + 1 });
      object.setCoords();
    }
  }

  const maxWidthTemplate = (window.previews || [])
    .map(p => p.id === _preview.id ? nextDimension : p.dimension)
    .map(dimension => Array.isArray(dimension) ? Number(dimension[0]) : 0)
    .filter(width => Number.isFinite(width))
    .reduce((acc, width) => acc < width ? width : acc, 0);
  let ratio = Math.min(widthTemplateGroupPreview / newWidth, 1);

  if (layout_options?.sizing_view === GRID_SIZING_VIEW) {
    ratio = ratio = Math.min(widthTemplateGroupPreview / (DEFAUL_GRID_COLUMNS / _preview.settings.w) / newWidth, 1);
  }

  if (layout_options?.sizing_view === PROPORTIONAL_SIZING_VIEW) {
    ratio = Math.min(widthTemplateGroupPreview / maxWidthTemplate, ratio);
  }

  const upperCanvasEl = _preview.canvas.upperCanvasEl;
  const templateItem = $(upperCanvasEl.closest(".template-item"));

  const biggestSide = Math.max(newWidth, newHeight);

  // This resize path owns the canvas dimensions below. The zoom helpers also mutate
  // wrapper/grid DOM state based on stale pre-resize dimensions, which makes the
  // immediate preview differ from the freshly loaded preview.
  if (biggestSide > ZoomService.MAX_CANVAS_SIZE) {
    const scaleFactor = ZoomService.MAX_CANVAS_SIZE / biggestSide;
    _preview.canvas.setZoom(scaleFactor);
  } else {
    _preview.canvas.setZoom(1);
  }

  _preview.canvas.setDimensions({
    width: newWidth * _preview.canvas.getZoom(),
    height: newHeight * _preview.canvas.getZoom()
  });

  let cWidth = newWidth * ratio;
  let cHeight = newHeight * ratio;

  templateItem.find('.grid-stack-item').css('height', cHeight);
  _preview.canvas.setDimensions({
    width: `${cWidth}px`,
    height: `${cHeight}px`,
  }, {
    cssOnly: true,
  });
  
  _preview.dimension = nextDimension;
}
async function copyResizedTemplate(data, needReload = true, createBasetemplate = false, createNewLayout = false, context = copyAndResizeButtonContext) {
  const { onClickDuplicateTemplateButton } = getShowPageScope();
  await onClickDuplicateTemplateButton.bind(context)(JSON.stringify(data), needReload, createBasetemplate, createNewLayout);
}

async function deleteTemplate(instanceId, customerId, layoutId) {
  const fd = new FormData();
  fd.append('_method', 'delete');
  
  await axios.post(
    `/banner/${customerId}/group/${layoutId}/template/${instanceId}`,
    fd
  );
}

copyAndResizeEventBroker.on(EVENTS.BULK_COPY, async (state) => {
  const { getChangesLayoutById, previews } = getShowPageScope();
  const { selectedSizes, deleteOriginalTemplates, customerId, layoutId } = state;
  
  const lastPreview = previews[previews.length - 1];
  for (let preview of previews) {
    const resizedData = [];
    for (let dimension of selectedSizes) {
      resizeTemplateHandler({
        isCopyObject: true,
        dimension,
        state,
        preview: preview
      });

      let objectData = deepCopy(getChangesLayoutById(preview.id))
      if (objectData && dimension && dimension.template) {
        objectData.source_template_id = dimension.template.id;
      }
      resizedData.push(objectData);
    }
    const button = $('.resize-template[data-url]').filter(function () {
      return $(this).data('id') === preview.id;
    });

    copyAndResizeButtonContext = button;
    await copyResizedTemplate(resizedData, lastPreview.id === preview.id ? true : false);
    if (deleteOriginalTemplates) {
      await deleteTemplate(preview.id, customerId, layoutId);
    }
  }
  copyAndResizeEventBroker.fire(EVENTS.CLOSED);
});

copyAndResizeEventBroker.on(EVENTS.BULK_COPY_SELECTED, async (state) => {
  const {
    customerId,
    layoutId,
    selectedSizes,
    alignContent,
    deleteOriginalTemplates,
    selectedTemplateIds
  } = state;

  const { data } = await axios.post(`/banner/${customerId}/group/${layoutId}/bulk-resize-selected`, {
      selectedSizes,
      alignContent,
      deleteOriginalTemplates,
      selectedTemplateIds,
    }
  );

  const url = new URL(window.location.href);
  if (url.searchParams.has('selectedTemplates') && data.newTemplateIds?.length) {
    url.searchParams.set('selectedTemplates', data.newTemplateIds.join('_'));
    window.history.replaceState({}, '', url);
  }

  window.location.reload();
});

copyAndResizeEventBroker.on(EVENTS.SAVED, async (state) => {
  const { saveLayout, layoutChanges, canvas_data } = getShowPageScope();
  const { isMultiSizes, selectedSizes, statePreview, createBasetemplate, createNewLayout } = state;
  const sourcePreview = statePreview || currentPreview;
  const copyContext = copyAndResizeButtonContext;
  let copyState = null;

  try {
    if (isMultiSizes) {
      if (!$(copyContext).data('url')) {
        throw new Error('The copy action is unavailable for this template.');
      }
      if (layoutChanges.length) {
        const didSave = await saveLayout(false);
        if (!didSave) {
          throw new Error('Could not save the source layout.');
        }
      }
      // Copy handlers collect resize data by temporarily updating the source settings.
      copyState = {
        changes: deepCopy(layoutChanges),
        settings: [sourcePreview.data, canvas_data[sourcePreview.id]._data]
          .map(target => ({ target, data: deepCopy(target) })),
      };
    }

    window.AutoSave.isPaused = true;
    store.commit('layout/SET_IS_TEMPLATES_RESIZING', true);

    if (!isMultiSizes) {
      const { width, height } = selectedSizes[0];

      if (state.isAutoPosition) {
        await resizeAITemplateHandler({
          isCopyObject: false,
          dimensions: selectedSizes,
          state,
          preview: sourcePreview,
          beforeApplyResizedTemplate: ({ dimension }) => {
            changeTemplateCanvasElement(dimension.width, dimension.height, sourcePreview, {
              useCurrentPreviewWidth: true,
            });
          }
        });
      } else {
        resizeTemplateHandler({
          isCopyObject: false,
          dimension: selectedSizes[0],
          state,
          preview: sourcePreview,
        });
      }

      changeNameOfTemplate(width, height, sourcePreview);

      if (!state.isAutoPosition) {
        changeTemplateCanvasElement(width, height, sourcePreview);
      }
    } else {
      const resizedData = [];

      if (state.isAutoPosition) {
        const resizedAIData = await resizeAITemplateHandler({
          isCopyObject: true,
          dimensions: selectedSizes,
          state,
          preview: sourcePreview
        });
        resizedData.push(...resizedAIData);
      } else {
        for (let dimension of selectedSizes) {
          resizeTemplateHandler({
            isCopyObject: true,
            dimension,
            state,
            preview: sourcePreview
          });
          const objectData = getResizedObjectsData(sourcePreview.id, dimension);
          resizedData.push(objectData);
        }
      }

      await copyResizedTemplate(resizedData, true, createBasetemplate, createNewLayout, copyContext);
    }

    copyAndResizeEventBroker.fire(EVENTS.CLOSED);
  } catch (error) {
    toastr.error('Could not resize this template. Please try another size or adjust the layout manually.');
    copyAndResizeEventBroker.fire(EVENTS.FAILED);
  } finally {
    if (copyState) {
      layoutChanges.splice(0, layoutChanges.length, ...copyState.changes);
      copyState.settings.forEach(({ target, data }) => {
        Object.keys(target).forEach(key => {
          delete target[key];
        });
        Object.assign(target, data);
      });
    }
    window.AutoSave.isPaused = false;
    store.commit('layout/SET_IS_TEMPLATES_RESIZING', false);
  }
});

export const getObjectsForOrder = (objects) => objects
  .filter(object => !NOT_PROCESSED_OBJECTS.includes(object.id))
  .map(object => {
    if (object.get('type') === 'group') {
      const objects = object.getObjects();
      return {
        name: 'Group',
        isGroup: true,
        target: object,
        id: object.id,
        visible: false,
        objects: getObjectsForOrder(objects),
      }
    }

    return {
      name: object?.templateField?.name || object?.name,
      target: object,
      objects: [],
      id: object.id,
      visible: object.visible ?? null,
      templateFieldId: object?.templateField?.id,
      fileName: object.fileName
    }
  });

export const handlerButton = ({
  instanceId, 
  withCopingTemplate, 
  preselectedSizes = [],
  resizeHint = '',
  orientationHints = {},
  createNewLayout = false,
  instantRun = false,
  context = null,
}) => {
  const { previews } = getShowPageScope();
  const { COPY_AND_RESIZE, RESIZE} = MODAL_TITLES;
  
  const preview = previews.find(preview => preview.id === instanceId);
  currentPreview = preview;
  
  const objects = getObjectsForOrder(preview.canvas.getObjects());
  
  const fields = objects.map(object => {
    let thumbnail = null;
    
    if (object.target._element) {
      const url = new URL(object.target._element.currentSrc);
      url.searchParams.set('lightweight', '');
      url.searchParams.set('scale_width', '30');

      thumbnail = url;
    }
    
    return {
      id: object.target.id,
      name: object.name,
      type: object.target.templateField?.type || FIELD_TYPE_BACKGROND_THEME_IMAGE,
      thumbnail: thumbnail || DEFAULT_BACKGROUND_THEME_IMAGE_FIELD_PROPERTIES.additional_background_images,
    }
  })
  
  const copyButton = $(context).filter(function () {
    return $(this).data('id') === instanceId && $(this).data('url');
  });
  copyAndResizeButtonContext = copyButton.length ? copyButton.first()
    : $('.resize-template[data-url]').filter(function () {
      return $(this).data('id') === instanceId;
    }).first();

  copyAndResizeEventBroker.fire(EVENTS.INIT, {
    title: withCopingTemplate ? COPY_AND_RESIZE : RESIZE,
    isMultiSizes: true,
    allowCreateNewLayout: !!withCopingTemplate,
    fields,
    canvasSize: {
      width: preview.canvas.width,
      height: preview.canvas.height,
    },
    preview,
    objects: objects,
    preselectedSizes,
    resizeHint,
    orientationHints,
    createNewLayout,
    instantRun
  });
}
  
export function initCopyAndResizeHandler($row) {
  const $button = $row.find('.resize-template');

  $button.on('click', function () {
    const { id, withCopingTemplate } = $(this).data();
    handlerButton({
      instanceId: id, 
      withCopingTemplate,
      context: this,
    });
  });
}
